import 'reflect-metadata'
import './fix'
import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/main.scss'
import '@patsnap-biz/design-tokens/scss/_variables-RD.css';
import { startup } from '@eureka/startup'
import { accountDeferred } from '@eureka/utils/account';
import { headerService } from '@/services/header-service';
import { i18n } from '@/infrastructure/locales'
import router from './routes';
import { container } from './inversify.config';
import { setContainer, ErrorHandler, ErrorHandlerRegistry, injectService } from '@patsnap/tahiti-core';

setContainer(container);

injectService<ErrorHandler>(ErrorHandler).onStart();
injectService<ErrorHandlerRegistry>(ErrorHandlerRegistry).onStart();

startup({
    headerService,
    projectName: 'eureka',
    preset: {
        name: 'eureka',
    },
    pageInit() {
        return Promise.resolve()
    },
    disableBrowserFavorite: true,
    disableCustomerService: true,
});

accountDeferred.promise.then(
    () => {
        import('@eureka/startup/src/help-center').then(({ getHelpCenter }) => {
            getHelpCenter(i18n.global, headerService)
        })
    }
);

const app = createApp(App);
app.config.throwUnhandledErrorInProduction = true;
app
    .use(router)
    .use(i18n)
    .mount('#app');
